import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import {
  PostAutoTuneV2Config,
  PostPowerCurtail,
} from "../../api/api";

type ManualPowerCurtailNowResult = {
  status: string;
  msg?: string;
};

type ManualPowerCurtailProps = {
  siteName: string;
  eventType: string;
  operation: string;
  start_time?: string;
  end_time?: string;
  scheduleOp?: string;
  rampup_time?: number;
  id?: string;
  source?: string;
  target_power_usage: number;
};

export const usePowerCurtail = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      token,
      operation_type,
      ...params
    }: ManualPowerCurtailProps & {
      token: string;
      operation_type: string;
    }): Promise<ManualPowerCurtailNowResult> =>
      PostPowerCurtail(
        token,
        {
          ...params,
        },
        operation_type
      ),

    onSuccess: (data) => {},

    onError: (error) => {
      console.error(
        "Error performing miner operations:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      {
        ...params
      }: ManualPowerCurtailProps & {
        operation_type: string;
      },
      options?: {
        onSuccess?: (
          data: ManualPowerCurtailNowResult
        ) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      mutation.mutateAsync(
        {
          ...params,
          token,
          // Ensure this is included
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
